export default __webpack_public_path__ + "static/media/notification.17b6e895.svg";